import { useCallback, useState } from 'react'

export const usePopoverVisible = () => {
    const [visible, setVisible] = useState(false)
    const hidden = useCallback(() => {
        setVisible(false)
    }, [])

    return {
        options: {
            visible,
            onVisibleChange: (visible: boolean) => setVisible(visible),
        },
        hidden,
    }
}
